import { Logger } from 'common/logger';

const defaultValue = { power_sales_price: { value: null } };

export const powerPrice = {
    name: 'powerPrice',
    state: { ...defaultValue },

    reducers: {
        update(state, payload) {
            Logger.log('powerPrice.update:', payload);
            return { ...state, ...payload };
        },
    },
};

export default powerPrice;
